export enum TDSpeedType {
  'TIMBERING' = 'TSS',
  'SURFACING' = 'SST'
}
